import React from "react"
import { Box, Button, CircularProgress, Typography } from "@mui/material"
import InfoIcon from "@mui/icons-material/InfoOutlined"
import { PANEL_BUTTON_SX } from "@/theme/panelStyles"
import { DANGER } from "@/theme/tokens"

// Same look as the Fleet Explorer Back button, footer geometry on top.
const SECONDARY_SX = {
  ...PANEL_BUTTON_SX,
  flex: "0 0 auto",
  px: 2.25,
  py: 1,
  fontSize: "13.5px",
}

function WizardFooter({
  secondaryLabel,
  onSecondary,
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  primaryLoading = false,
  primaryColor = "#004f7d",
  primaryHints = null,
}) {
  return (
    <Box
      data-tour="planner-footer"
      sx={{
        flexShrink: 0,
        mx: -1.5,
        mb: -1.5,
        px: 1.75,
        py: 1.25,
        borderTop: "1px solid #e2e8ee",
        boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
        bgcolor: "#fff",
      }}
    >
      {primaryHints?.length > 0 && (
        <Box sx={{ mb: 0.75 }}>
          {primaryHints.map((hint) => (
            <Box
              key={hint}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              <InfoIcon sx={{ fontSize: 14, color: DANGER }} />
              <Typography sx={{ fontSize: "11px", color: DANGER }}>
                {hint}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button variant="contained" onClick={onSecondary} sx={SECONDARY_SX}>
          {secondaryLabel}
        </Button>
        <Button
          data-tour="planner-primary"
          variant="contained"
          onClick={onPrimary}
          disabled={primaryDisabled}
          loading={primaryLoading}
          loadingPosition="start"
          loadingIndicator={
            <CircularProgress size={12} thickness={5} sx={{ color: "#fff" }} />
          }
          sx={{
            flex: 1,
            minWidth: 0,
            py: 1,
            borderRadius: "12px",
            bgcolor: primaryColor,
            color: "#fff",
            fontSize: "13.5px",
            fontWeight: 600,
            textTransform: "none",
            // Busy looks like the banner's Update button: keeps its colour, label stays readable.
            ...(primaryLoading && {
              "&.Mui-disabled": { bgcolor: primaryColor, color: "#fff", opacity: 0.7 },
            }),
          }}
        >
          {primaryLabel}
        </Button>
      </Box>
    </Box>
  )
}

export default React.memo(WizardFooter)
